import { create } from 'zustand';

import { DeviceDto } from '~modules/device/model';
import { SectionDto } from '~modules/section/model';

export type DeviceWithKey = Partial<DeviceDto> & { key: string };
export type ErrorsType = {
	title?: string | null;
	lat?: string | null;
	lon?: string | null;
} & { [key: string]: string | null };

type StoreType = {
	section: Partial<SectionDto>;
	devices: DeviceWithKey[];
	errors: ErrorsType;
	setSection: (section: Partial<SectionDto>) => void;
	setDevices: (devices: DeviceWithKey[]) => void;
	clearErrors: () => void;
	setError: (key: string, value: string | null) => void;
	changeTitle: (title: string) => void;
};

export const editStore = create<StoreType>(set => ({
	section: {},
	devices: [],
	errors: {},
	setSection: (section: Partial<SectionDto>) => set(old => ({ ...old, section })),
	setDevices: (devices: DeviceWithKey[]) => set(old => ({ ...old, devices })),
	clearErrors: () => set(old => ({ ...old, errors: {} })),
	setError: (key: string, value: string | null) => set(old => ({ ...old, errors: { ...old.errors, [key]: value } })),
	changeTitle: title => set(old => ({ ...old, section: { ...old.section, title } })),
}));
